export const news = [
  {
    id: 1,
    title: "Income Tax Act 2025 Comes into Effect from April 1, 2026",
    date: "2026-04-01",
    source: "CBDT",
    category: "Income Tax",
    excerpt: "India's new Income Tax Act 2025 officially replaces the 1961 law. Key changes include the 'Tax Year' concept replacing FY/AY, 536 sections (down from 800+), Form 130 replacing Form 16, extended ITR deadlines, and simplified compliance language. The new regime with zero tax up to Rs. 12 lakh is now the default."
  },
  {
    id: 2,
    title: "TDS Rules 2026: New Sections 392 & 393 Replace Old TDS Framework",
    date: "2026-03-28",
    source: "Income Tax Department",
    category: "Income Tax",
    excerpt: "Under the Income Tax Act 2025, TDS on salary moves to Section 392 and all other TDS provisions consolidate under Section 393. New Section 194T (now under 393) applies TDS on partner salary/remuneration above Rs. 20,000. Cash withdrawal limits raised to Rs. 3 Cr for co-operative societies under Section 194N."
  },
  {
    id: 3,
    title: "TDS 2026 vs Old Rules: Key Differences Every Business Must Know",
    date: "2026-03-25",
    source: "CBDT Circular",
    category: "Income Tax",
    excerpt: "While TDS rates remain largely unchanged, the new Act restructures section numbering, introduces code-based reporting under Section 393, makes the new tax regime default (Rs. 75,000 standard deduction), and requires Form 130 instead of Form 16. Businesses must update their TDS software and ERP systems before April 1."
  },
  {
    id: 4,
    title: "MSME Compliance Tightened: Payment Delays Now Impact Income Tax",
    date: "2026-03-20",
    source: "Ministry of MSME",
    category: "MSME",
    excerpt: "Under the new Act, businesses delaying payments to MSME vendors beyond the agreed period face disallowance of the expense for income tax purposes. This strengthens MSME cash flow protection and aligns with the government's 'facilitate first, enforce later' approach under Finance Bill 2026."
  },
  {
    id: 5,
    title: "GST Reforms April 2026: E-Invoicing Mandatory for Rs. 5 Cr+ AATO",
    date: "2026-03-15",
    source: "CBIC",
    category: "GST",
    excerpt: "From April 1, 2026, e-invoicing is mandatory for businesses with aggregate annual turnover above Rs. 5 crore. A 30-day IRP reporting limit applies for businesses above Rs. 10 crore — late invoices will be invalid for ITC claims. New invoice series and LUT filings are required for FY 2026-27."
  },
  {
    id: 6,
    title: "Finance Bill 2026: Trust-Based Tax Regime, Reduced Penalties for Technical Defaults",
    date: "2026-02-01",
    source: "Ministry of Finance",
    category: "Finance",
    excerpt: "The Finance Bill 2026 introduces a facilitative compliance approach — converting penalties for technical defaults (like late audits) into predictable fixed fees. This reduces litigation risk for MSMEs and promotes voluntary compliance. Tax audit thresholds remain Rs. 1 crore (Rs. 10 crore if cash < 5%)."
  },
  {
    id: 7,
    title: "HRA Exemption Expanded to 8 Metro Cities from April 2026",
    date: "2026-03-10",
    source: "CBDT",
    category: "Income Tax",
    excerpt: "The 50% HRA exemption now covers 8 cities: Delhi, Mumbai, Kolkata, Chennai, Bengaluru, Pune, Hyderabad, and Ahmedabad. New Form 124 replaces Form 12BB and requires disclosure of landlord relationship. Rent paid to relatives is now allowed with proper documentation."
  },
  {
    id: 8,
    title: "GST Bank Account Verification Mandatory from January 2026",
    date: "2026-01-05",
    source: "GSTN",
    category: "GST",
    excerpt: "All GST-registered businesses must have valid bank account details (account number and IFSC) verified on the GST portal. Non-compliance blocks GST operations. Returns will also be blocked if ITC mismatches the electronic credit ledger or RCM remains unpaid."
  },
  {
    id: 9,
    title: "TCS Rationalized to Uniform 2% Under Section 394 from April 2026",
    date: "2026-03-22",
    source: "CBIC",
    category: "Income Tax",
    excerpt: "Multiple TCS categories — including alcoholic liquor, scrap, coal/lignite, tendu leaves, and overseas tour packages — are now subject to a uniform 2% TCS rate under new Section 394. LRS for education and medical purposes also standardized at 2%, down from the earlier 5-20% slab structure."
  },
  {
    id: 10,
    title: "Digital Compliance Push: Auto-Populated Returns and Faceless Assessments",
    date: "2026-02-15",
    source: "Income Tax Department",
    category: "Income Tax",
    excerpt: "The government accelerates digital compliance with AI-driven faceless assessments, auto-populated ITR fields, and API-based GST filing. MSME registrations are auto-approved within 3 days if monthly ITC is below Rs. 2.5 lakh. Risk-based auto-refunds processed within 7 days."
  },
  {
    id: 11,
    title: "New Credit Guarantee Scheme for First-Time MSME Entrepreneurs",
    date: "2026-02-10",
    source: "Ministry of MSME",
    category: "MSME",
    excerpt: "A new credit guarantee scheme offers collateral-free loans up to Rs. 1 crore for first-time entrepreneurs, with reduced interest rates and simplified application. Priority sector lending benefits for MSMEs extended. Investor-ready financial statements now a key requirement for approvals."
  },
  {
    id: 12,
    title: "MCA Simplified Annual Filing for Small Companies in 2026",
    date: "2026-01-10",
    source: "Ministry of Corporate Affairs",
    category: "Corporate",
    excerpt: "The MCA has introduced a simplified one-form annual filing process for small companies, reducing compliance burden and cost. Combined with the new Income Tax Act's streamlined structure, this marks a significant reduction in regulatory overhead for growing businesses."
  }
];
